import { flatten } from 'lodash'
import { useInfiniteQuery } from 'react-query'

import { CacheKeys } from '../../helpers/cacheKeys'
import { parseQueryParams } from '../../helpers/utils'
import { fetchDrivingViolations } from '../../models/employment'

export function useDrivingViolations({
  isDisabled = false,
  userId,
}: {
  isDisabled?: boolean
  userId: string
}) {
  const { data, fetchNextPage, hasNextPage, isFetching, refetch, isLoading } = useInfiniteQuery(
    CacheKeys.DRIVING_VIOLATIONS,
    ({ pageParam = 1 }) => fetchDrivingViolations({ page: pageParam, userId }),
    {
      enabled: !isDisabled,
      refetchOnWindowFocus: false,
      getNextPageParam: (lastPage) => (lastPage.next ? parseQueryParams(lastPage.next).page : null),
    }
  )

  return {
    violations: flatten(data?.pages.map((page) => page.results)),
    refetch,
    isLoading,
    isFetching,
    hasNextPage,
    fetchNextPage,
  }
}
